import Medias from '@/js/medias'

const BackgroundImage = {}

BackgroundImage.install = function (Vue, options) {

	Vue.directive('bg', {
		inserted (el, binding, vnode, oldVnode) {
			if (binding.value) {
				if (el.tagName === 'IMG')
					el.src = Medias.get({ name: binding.value })
				else
					el.style.backgroundImage = 'url(' + Medias.get({ name: binding.value }) + ')'
			}
		},
		update(el, binding, vnode, oldVnode) {
			if (binding.value !== binding.oldValue)
				if (el.tagName === 'IMG')
					el.src = Medias.get({ name: binding.value })
				else
					el.style.backgroundImage = 'url(' + Medias.get({ name: binding.value }) + ')'
		}
	})

}

export default BackgroundImage
